<template>
  <div class="dialog-fail">
    <mt-popup v-model="isVisible" popup-transition="popup-fade" :closeOnClickModal="true">
      <div class="popup-header">
        <div class="title mar-t-20">限额说明</div>
      </div>
      <div class="popup-body mar-t-20">
        <div class="card-con">
          <div class="bank-name">{{selectCard.other_branch_name}}</div>
          <div class="card-num mar-t-1">{{selectCard.other_acct_no}}</div>
          <div class="limit-hint mar-t-1">单笔 &yen;{{selectCard.daily_single_limit}} 单日 &yen;{{selectCard.daily_limit}}</div>
          <div class="border mar-t-1"></div>
          <div class="desc mar-t-1">
            银行卡的支付限额是由银行设置的，充值转账、购物支付等场景限额共享，无法提升。若提示超限，建议更换其他付款方式。
          </div>
        </div>
      </div>
      <div class="popup-footer mar-t-20">
        <button type="button" class="btn-close" @click="isVisible = false">我知道了</button>
      </div>
    </mt-popup>
  </div>
</template>

<script>
export default {
  name: 'dialogFail',
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
      // validator: function (value) {
      //   return value >= 0
      // }
    },
    selectCard: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // dialogName: 'fail'
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('closeDialog')
        }
      }
    },
  },
  methods: {
  },
  created() {

  },
  mounted() {

  },
  components: {
  }
}
</script>
<style lang="less" scoped>
.qrcode {
  width: 60%;
}

.sub-text {
  font-size: 12px;
}
.mint-popup {
  width: 300px;
  background-color: #fff;
  border-radius: 5px;
  max-height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  overflow: hidden;
  top: 40%;
  .popup-header {
    flex: 0 0 auto;
    height: 40px;
    font-size: 18px;
    line-height: 40px;
    text-align: center;
    color: #333;
  }

  .popup-body {
    flex: 1 1 auto;

    min-height: 100px;
    overflow: auto;

    padding: 20px;
    // -webkit-mask: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 20px, rgba(0, 0, 0, 1) calc(~"100% - 20px"), rgba(0, 0, 0, 0) 100%);
    .card-con {
      .bank-name {
        color: #66748a;
        font-size: 16px;
      }
      .card-num {
        color: #97a4b8;
        font-size: 18px;
      }
      .limit-hint {
        font-size: 14px;
        color: #666;
      }
      .border {
        border-top: 1px solid #eee;
      }
      .desc {
        font-size: 12px;
        color: #999;
        line-height: 1.6;
      }
    }
  }

  .popup-footer {
    flex: 0 0 auto;
    padding: 10px;
    .btn-close {
      background-color: #3b8aff;
      color: #fff;
      border: none;
      width: 100%;
      height: 0.44rem;
      line-height: 0.44rem;
      font-size: 16px;
    }
  }

  // .btn-close {
  //   .bgImg(  '../images/sprites/dialog_close_w.png',0.5);
  //   .bgSprite(h);
  //   bottom: -60px;
  // }
}
.mar-t-1 {
  margin-top: 0.1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog_daily_limit.vue